module.exports = __webpack_public_path__ + "img/icon-ship.1f8e47e.png";